import { __rest } from "tslib";
import clsx from 'clsx';
import { node, oneOf, oneOfType, shape, string } from 'prop-types';
import React from 'react';
import ColumnLayout from '../ColumnLayout';
import PageBackground from '../PageBackground';
import PageFooter from '../PageFooter';
import PageHeader from '../PageHeader';
import './PageTemplate.less';
const LAYOUTS = {
    column: ColumnLayout,
};
export default function PageTemplate(props) {
    const { header = false, layout = false, footerProps, children, className } = props, otherProps = __rest(props, ["header", "layout", "footerProps", "children", "className"]);
    const LayoutComponent = LAYOUTS[layout];
    const headerElement = typeof header === 'string' ? React.createElement(PageHeader, null, header) : header;
    return (React.createElement("div", Object.assign({ className: clsx('kal-page-template', className) }, otherProps),
        headerElement,
        React.createElement(PageBackground, { className: 'kal-page-template-background' }, LayoutComponent ? React.createElement(LayoutComponent, null, children) : children),
        React.createElement(PageFooter, Object.assign({}, footerProps))));
}
PageTemplate.propTypes = {
    /** If a string, rendered at the top of the page in a <PageHeader> element. Anything else will just be rendered at the top of the page. */
    header: oneOfType([string, node]),
    /** If set, applies a standard layout to the page content */
    layout: oneOf(['column']),
    /** Passed directly to the <PageFooter> component */
    footerProps: shape({}),
    /** Rendered as page content */
    children: node,
    /** Applied directly to the root DOM node */
    className: string,
};
//# sourceMappingURL=PageTemplate.js.map